if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      let sizeOptions = !!document.querySelector('.product-form__input--size.product-form__input input[type=radio]:checked');
      if (sizeOptions == false) {
        document.querySelector('.product-side-sticky').classList.add('select-size__prompt');
        return;
      }
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = window.fetchConfig('javascript');

      const formData = new FormData(this.form);
      formData.append('sections_url', window.location.pathname);
      const mainLineItem = {};
      formData.forEach((value, key) => {
        if (key.includes('properties[')) {
          mainLineItem.properties = mainLineItem.properties || {};
          const propertyKey = key.match(/properties\[(.*)\]/)[1];
          mainLineItem.properties[propertyKey] = value;
        } else {
          mainLineItem[key] = value;
        }
      });
      const body = {
        items: [mainLineItem],
      };

      if (
        mainLineItem.properties
        // eslint-disable-next-line no-underscore-dangle
        && mainLineItem.properties._isEmbroidered
        && window.SDG
        && window.SDG.Product
        && window.SDG.Product.embroideryFeeProductSelector
      ) {
        const embroideryFeeVariantId = window.SDG.Product.embroideryFeeProductSelector;

        if (embroideryFeeVariantId) {
          body.items.push({
            id: embroideryFeeVariantId,
            quantity: mainLineItem.quantity,
            properties: {
              _isEmbroideryFee: true,
              _embroideryVariantId: mainLineItem.id,
              _customization: mainLineItem.properties.customization,
              _threadColor: mainLineItem.properties.threadColor,
              _placementPosition: mainLineItem.properties.placementPosition,
              _fontType: mainLineItem.properties.fontType,
            },
          });
        }
      }

      config.body = JSON.stringify(body);

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          if (window.theme.cartType === 'drawer') {
            const quantityElement = this.form.querySelector('[name="quantity"]');
            // We simply trigger an event so the mini-cart can re-render
            this.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                quantity: quantityElement ? parseInt(quantityElement.value, 10) : 1,
              },
            }));
          } else {
            window.location.href = window.routes.cartUrl;
          }

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
